import classNames from 'classnames';
import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { HighlightColor } from 'components/shared/NumberFormatter/NumberFormatter.model';
import { ReactNode, KeyboardEvent } from 'react';

import './style.scss';
import { AddOrRemoveButtons } from './add-or-remove-buttons';
import { PresetsButtons } from './presets-buttons';

export type DigitInputProps = {
  id: string;
  value: Nullable<number>;
  label: string;
  unit?: string;
  className?: string;
  valuePresets?: number[];
  precision?: number;
  decimalPadding?: boolean;
  isReadOnly?: boolean;
  isInvalid?: boolean;
  highlightColor?: HighlightColor;
  append?: ReactNode;
  incrementStep?: number;
  onValueChanged: (value: Nullable<number>) => void;
  onAddOrRemove: (action: 'add' | 'remove') => void;
  onKeyPress?: (e: KeyboardEvent) => void;
};

export function DigitInput({
  value,
  label,
  unit,
  id,
  onValueChanged,
  onAddOrRemove,
  valuePresets,
  className,
  precision,
  decimalPadding,
  isReadOnly = false,
  isInvalid = false,
  highlightColor,
  append,
  onKeyPress,
  incrementStep,
}: DigitInputProps) {
  const handleOnBlur = (val: number | undefined) => {
    const newValue: Nullable<number> = val !== undefined ? val : null;
    onValueChanged(newValue);
  };

  return (
    <div
      className={classNames('digit-input-container input-group bg-lvl1', {
        'is-readonly': isReadOnly,
      })}
    >
      <NumberFormatter
        id={id}
        value={value}
        onBlur={handleOnBlur}
        onKeyPress={onKeyPress}
        className={`input form-control-lg ps-3 fs-1 fw-medium ${className}`}
        precision={precision}
        decimalPadding={decimalPadding}
        isReadOnly={isReadOnly}
        hasError={isInvalid}
        highlightColor={highlightColor}
        incrementStep={incrementStep}
      />

      <div className="label input-icon-start w-auto px-12px">
        <label htmlFor={id} className="text-secondary">
          {label}
        </label>
      </div>

      <div className="input-icon-end">{append}</div>

      <PresetsButtons
        currentValue={value}
        valuePresets={valuePresets ?? []}
        onClick={onValueChanged}
        isDisabled={isReadOnly}
      />
      <div className="input-icon-end w-auto align-items-end">
        <div className="d-flex">
          {unit && <span className="text-secondary input-group-text align-self-stretch h-auto fs-6">{unit}</span>}
          <AddOrRemoveButtons onAddOrRemove={onAddOrRemove} isDisabled={isReadOnly} />
        </div>
      </div>
    </div>
  );
}
